import { Button as FableButton } from '@sainsburys-tech/fable';
import * as React from 'react';
export default {
  FableButton,
  React
};